import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import DateRangeType from "@mapmycustomers/shared/enum/DateRangeType";

import SelectField from "@app/component/input/SelectField";
import { getDateRangeTypeDisplayName } from "@app/util/ui";

interface BaseProps {
  className?: string;
  value: DateRangeType;
}

type Props = BaseProps &
  (
    | { allowAll: true; onChange?: (dateRangeType: DateRangeType) => void }
    | {
        allowAll?: false;
        onChange?: (dateRangeType: Exclude<DateRangeType, DateRangeType.ALL>) => void;
      }
  );

const RangeTypeSelect: React.FC<Props> = ({ allowAll, className, onChange, value }) => {
  const intl = useIntl();

  const options = useMemo(
    () =>
      Object.values(DateRangeType)
        .filter((type) => allowAll || type !== DateRangeType.ALL)
        .map((type) => ({
          label: getDateRangeTypeDisplayName(intl, type),
          value: type,
        })),
    [allowAll, intl]
  );

  return (
    <SelectField<DateRangeType>
      className={className}
      dropdownMatchSelectWidth={false}
      label={intl.formatMessage({
        id: "dateRangeSelect.timespan",
        defaultMessage: "Timespan",
        description: "Timespan field label in range selector component",
      })}
      // We know that the possible options are regulated by allowAll prop and that onChange
      // can't send ALL when allowAll is not true because we filter out such option in
      // options' useMemo
      // @ts-ignore
      onChange={onChange}
      options={options}
      value={value}
    />
  );
};

export default RangeTypeSelect;
